export const getParams = (name: string) => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const getOriginUrl = () => {
  const {origin, protocol, hostname, port} = location;
  return origin ? origin : `${protocol}//${hostname}${port && ':' + port}`;
};

export const getFullUrl = () => {
  const {pathname} = location;
  return `${getOriginUrl()}/${pathname}`;
};

/**
 * hrefがhoge#accessになっているかどうか
 * @param href
 */
export const isCurrentHashLink = (href: string): boolean => {
  const {pathname} = location;
  return pathname !== '/' && href.includes(pathname) && href.includes('#');
};
